// extracted by mini-css-extract-plugin
export default {"list":"InlineNav_list__fdipG","anchor":"InlineNav_anchor__jp7CM"};